export enum BUTTON_TYPES {
  NORMAL = 'NORMAL',
  WIDE = 'WIDE',
  INVERTED = 'INVERTED',
  INVERTED_WIDE = 'INVERTED_WIDE'
}

export enum FORM_CHOICE_TYPES {
  RABBIT = 'RABBIT',
  DOG = 'DOG',
  CAT = 'CAT',
  HORSE = 'HORSE',
  DUCK = 'DUCK',
  GUINEA_PIG = 'GUINEA_PIG',
  ALL_PET_TYPES = 'ALL_PET_TYPES',
  GENDER = 'GENDER',
  NEUTRED = 'NEUTRED',
  ADD_PET = 'ADD_PET',
  RECURRENCE = 'RECURRENCE'
}

export const FORM_CHOICE_COMPONENT_TYPES = {
  ALL_PET_TYPES: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [
      { option: 'formChoiceTypes.allPetTypes.dogOption', value: 'DOG', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.allPetTypes.catOption', value: 'CAT', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.allPetTypes.rabbitOption', value: 'RABBIT', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.allPetTypes.horseOption', value: 'HORSE', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.allPetTypes.duckOption', value: 'DUCK', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.allPetTypes.guineaPigOption', value: 'GUINEA_PIG', buttonType: BUTTON_TYPES.NORMAL }
    ],
    registerAs: 'TYPE'
  },
  DOG: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [{ option: 'formChoiceTypes.allPetTypes.dogOption', value: 'DOG', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  CAT: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [{ option: 'formChoiceTypes.allPetTypes.catOption', value: 'CAT', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  RABBIT: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [{ option: 'formChoiceTypes.allPetTypes.rabbitOption', value: 'RABBIT', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  HORSE: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [{ option: 'formChoiceTypes.allPetTypes.horseOption', value: 'HORSE', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  DUCK: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [{ option: 'formChoiceTypes.allPetTypes.duckOption', value: 'DUCK', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  GUINEA_PIG: {
    title: 'formChoiceTypes.allPetTypes.title',
    options: [{ option: 'formChoiceTypes.allPetTypes.guineaPigOption', value: 'GUINEA_PIG', buttonType: BUTTON_TYPES.NORMAL }],
    registerAs: 'TYPE'
  },
  GENDER: {
    title: 'formChoiceTypes.gender.title',
    options: [
      { option: 'formChoiceTypes.gender.maleOption', value: 'MALE', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.gender.femaleOption', value: 'FEMALE', buttonType: BUTTON_TYPES.NORMAL }
    ],
    registerAs: 'GENDER'
  },
  NEUTRED: {
    title: 'formChoiceTypes.neutered.title',
    options: [
      { option: 'formChoiceTypes.neutered.yesOption', value: 'true', buttonType: BUTTON_TYPES.NORMAL },
      { option: 'formChoiceTypes.neutered.noOption', value: 'false', buttonType: BUTTON_TYPES.NORMAL }
    ],
    registerAs: 'NEUTRED'
  },
  ADD_PET: {
    title: 'formChoiceTypes.addPet.title',
    options: [
      {
        option: 'formChoiceTypes.addPet.addAnotherPetOption',
        value: 'true',
        buttonType: BUTTON_TYPES.WIDE
      },
      {
        option: 'formChoiceTypes.addPet.continueBookingOption',
        value: 'false',
        buttonType: BUTTON_TYPES.INVERTED_WIDE
      }
    ],
    registerAs: 'ADD_PET'
  },
  RECURRENCE: {
    title: 'formChoiceTypes.recurrence.title',
    options: [
      {
        option: 'formChoiceTypes.recurrence.oneOffOption',
        value: 'one_off',
        buttonType: BUTTON_TYPES.WIDE
      },
      {
        option: 'formChoiceTypes.recurrence.repeatedOption',
        value: 'recurring',
        buttonType: BUTTON_TYPES.WIDE
      }
    ],
    registerAs: 'RECURRENCE'
  }
} as const;
